module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/flashback-phone.0abb2208.png";